import { render, staticRenderFns } from "./DatosRecoleccion.vue?vue&type=template&id=8cbf164c"
import script from "./DatosRecoleccion.vue?vue&type=script&lang=js"
export * from "./DatosRecoleccion.vue?vue&type=script&lang=js"
import style0 from "./DatosRecoleccion.vue?vue&type=style&index=0&id=8cbf164c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports